import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import modal from 'decorators/Modal/Modal';
import { videoViewRatings } from 'redux/saga/entities/bound';
import { updateRating, updateComment, invalidRating } from 'redux/modules/rating';
import { rateVideo } from './Videos.saga';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    rating: state.rating,
    video: videoViewRatings.select(state)
  };
};
export var mapDispatchToProps = {
  rateVideo: rateVideo,
  updateRating: updateRating,
  updateComment: updateComment,
  invalidRating: invalidRating
};
export var modalConfig = {
  headerClass: 'modal__video-rating'
};
export var VideosRatingsModalUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VideosRatingsModalUnwrapped, _React$Component);

  function VideosRatingsModalUnwrapped(props) {
    var _this;

    _classCallCheck(this, VideosRatingsModalUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VideosRatingsModalUnwrapped).call(this, props));
    _this.state = {
      disableSubmit: true
    };
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VideosRatingsModalUnwrapped, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.video.data.length === 0) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props = this.props,
          rating = _this$props.rating,
          localRateVideo = _this$props.rateVideo,
          userId = _this$props.userId,
          video = _this$props.video,
          localInvalidRating = _this$props.invalidRating;
      this.setState({
        disableSubmit: true
      });

      if (rating.stars) {
        this.textInput.value = '';
        localRateVideo(userId, {
          video_event_id: video.data[0].video_event_id,
          rating: rating.stars,
          comment: rating.comment
        });
      } else {
        localInvalidRating();
      }
    }
  }, {
    key: "handleUpdateRating",
    value: function handleUpdateRating(star) {
      this.props.updateRating(star);
      this.setState({
        disableSubmit: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          video = _this$props2.video,
          rating = _this$props2.rating,
          localUpdateComment = _this$props2.updateComment;
      var _video$data$ = video.data[0],
          title = _video$data$.title,
          partner = _video$data$.partner,
          instructor = _video$data$.instructor;
      return React.createElement("div", null, React.createElement("div", {
        className: "modal__header modal__header--img pv++",
        style: {
          backgroundImage: "url(\"".concat(video.data[0].thumbnail_large_url, "\")")
        }
      }, React.createElement("div", {
        className: "modal__header__text"
      }, React.createElement("h4", null, title), React.createElement("p", null, partner.name), React.createElement("p", null, instructor))), React.createElement("div", {
        className: "modal__content pv++ text--center"
      }, React.createElement("h4", null, React.createElement(FormattedMessage, {
        id: "modal.ratings.h4",
        defaultMessage: "How was your workout?"
      })), React.createElement("div", {
        className: classNames('ratings ratings--form', _defineProperty({}, "ratings--rated-".concat(rating.stars), true))
      }, ['1', '2', '3', '4', '5'].map(function (star) {
        return React.createElement("div", {
          className: "ratings__star"
        }, React.createElement("input", {
          type: "radio",
          name: "rating",
          value: star,
          onClick: _this2.handleUpdateRating.bind(_this2, star)
        }));
      })), React.createElement("p", {
        className: classNames('error__text', {
          hidden: !rating.invalid
        })
      }, React.createElement(FormattedMessage, {
        id: "modal.ratings.star.error",
        defaultMessage: "Please select a star rating"
      })), React.createElement("textarea", {
        className: "mt- mb",
        onBlur: function onBlur(e) {
          return localUpdateComment(e.target.value);
        },
        ref: function ref(el) {
          return _this2.textInput = el;
        },
        rows: "3",
        cols: "30",
        placeholder: "Leave a review of this class to inform others in the ClassPass community."
      }), React.createElement("div", {
        className: "text--center"
      }, React.createElement("button", {
        onClick: this.handleSubmit,
        disabled: this.state.disableSubmit,
        className: "bt bt--primary bt--lg bt--width-md"
      }, React.createElement(FormattedMessage, {
        id: "modal.ratings.submit",
        defaultMessage: "Submit"
      })))));
    }
  }]);

  return VideosRatingsModalUnwrapped;
}(React.Component);
VideosRatingsModalUnwrapped.propTypes = {
  invalidRating: PropTypes.func.isRequired,
  rating: PropTypes.object.isRequired,
  rateVideo: PropTypes.func.isRequired,
  updateRating: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  video: PropTypes.object.isRequired
};
export var VideosRatingModalContainer = modal(modalConfig)(connect(mapStateToProps, mapDispatchToProps)(VideosRatingsModalUnwrapped));